import {useSelector} from 'react-redux';
import {ADMIN_ONLY_MODULES, hasPermission} from 'utils/permissions';

// usePermission('promocodes', 'create') -> boolean
// Reads permissions/hasFullAccess from the auth slice (populated by
// GET /api/v1/admin/my-permissions) and checks via the same hasPermission
// logic the backend uses, so a button only ever shows when the action would
// actually succeed server-side.
const usePermission = (moduleKey, action) => {
  const {permissions, hasFullAccess, isSystemAdmin} = useSelector((state) => state.auth);
  if (ADMIN_ONLY_MODULES.has(moduleKey)) return isSystemAdmin;
  if (hasFullAccess) return true;
  return hasPermission(permissions, moduleKey, action);
};

export default usePermission;
